import React, { useState, useEffect } from 'react';
import './ConvictionAlerts.css';

export default function ConvictionAlerts() {
  const [changes, setChanges] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const fetchChanges = async () => {
      setLoading(true);
      try {
        const res = await fetch('/api/score-history/changes?min_delta=0.5&days=7');
        if (res.ok) {
          const data = await res.json();
          setChanges(data);
        }
      } catch (err) {
        console.error('Failed to fetch conviction changes:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchChanges();
  }, []);

  if (dismissed || loading || changes.length === 0) return null;

  return (
    <div className="conviction-alerts">
      <div className="conviction-alerts-header">
        <span className="conviction-alerts-title">Conviction Score Changes (Last 7 Days)</span>
        <button className="conviction-alerts-dismiss" onClick={() => setDismissed(true)}>&times;</button>
      </div>
      <div className="conviction-alerts-list">
        {changes.slice(0, 5).map((change) => (
          <div key={change.symbol} className={`conviction-alert-item ${change.direction}`}>
            <span className="alert-symbol">{change.symbol}</span>
            <span className={`alert-delta ${change.direction}`}>
              {change.direction === 'improved' ? '+' : ''}{change.delta.toFixed(1)}
            </span>
            <span className="alert-detail">
              {change.previous_conviction?.toFixed(1)} &rarr; {change.current_conviction?.toFixed(1)}
            </span>
            {change.current_action && (
              <span className="alert-action">{change.current_action}</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
